import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { forwardRef as A, useCallback as g } from "react";
import { A as m } from "./Avatar-ihLwDM5D.js";
import { P as p } from "./Pill-uAcQLotY.js";
import { S as R } from "./SourcePill-CgQffD-I.js";
const S = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-2_5)",
  padding: "var(--space-3) var(--space-3)",
  background: "transparent",
  border: "none",
  borderRadius: "var(--radius-lg)",
  width: "100%",
  textAlign: "left",
  fontFamily: "var(--font-sans)",
  color: "var(--text-primary)",
  cursor: "pointer",
  transition: "background var(--duration-fast) var(--ease-out), opacity var(--duration-fast) var(--ease-out)"
}, h = {
  display: "block",
  fontSize: "var(--text-xs)",
  lineHeight: "var(--line-sm)",
  color: "var(--text-secondary)",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginTop: "var(--space-0_5)"
}, C = A(function({ conv: a, selected: r, onSelect: s, accountMode: i, disabled: l = !1, tabIndex: y = -1, labels: x = {} }, v) {
  const f = !!a.unread && i !== "auto", n = !!a.offTarget, d = !!a.pendingAction, c = g(() => {
    l || s(a.id);
  }, [a.id, l, s]), w = g(
    (u) => {
      (u.key === "Enter" || u.key === " ") && (u.preventDefault(), c());
    },
    [c]
  ), b = n ? "off-target" : d ? "pending" : f ? "unread" : null, z = {
    ...S,
    background: r ? "var(--bg-elevated)" : "transparent",
    opacity: n ? 0.78 : 1
  };
  return /* @__PURE__ */ o(
    "button",
    {
      ref: v,
      type: "button",
      role: "option",
      "aria-selected": r,
      "aria-disabled": l || void 0,
      "data-ls-component": "conv-row",
      "data-state": r ? "selected" : void 0,
      "data-unread": f || void 0,
      "data-off-target": n || void 0,
      "data-pending": d || void 0,
      "data-conv-id": a.id,
      tabIndex: l ? -1 : y,
      className: "ls-focus-ring ls-conv-row",
      style: z,
      onClick: c,
      onKeyDown: w,
      children: [
        /* @__PURE__ */ t(
          m,
          {
            size: "md",
            src: a.avatarUrl,
            initials: a.initials,
            tone: "neutral",
            badge: b,
            alt: typeof a.name == "string" ? a.name : ""
          }
        ),
        /* @__PURE__ */ o("div", { style: { flex: "1 1 auto", minWidth: 0 }, children: [
          /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
                gap: "var(--space-2)"
              },
              children: [
                /* @__PURE__ */ t(
                  "span",
                  {
                    style: {
                      fontSize: "var(--text-sm)",
                      lineHeight: "var(--line-sm)",
                      fontWeight: f ? 700 : 600,
                      color: "var(--text-primary)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "70%"
                    },
                    children: a.name
                  }
                ),
                /* @__PURE__ */ t(
                  "span",
                  {
                    style: {
                      fontSize: "var(--text-2xs)",
                      lineHeight: "var(--line-xs)",
                      color: "var(--text-tertiary)",
                      flex: "0 0 auto"
                    },
                    children: a.time
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t(P, { conv: a, pending: d, offTarget: n }),
          /* @__PURE__ */ t(k, { conv: a, pending: d, offTarget: n, labels: x })
        ] })
      ]
    }
  );
});
C.displayName = "ConvRow";
function P({ conv: e, pending: a, offTarget: r }) {
  return a && e.pendingAction ? /* @__PURE__ */ o(
    "span",
    {
      style: {
        ...h,
        color: "var(--magenta)",
        fontWeight: 600
      },
      children: [
        e.pendingAction.icon ? /* @__PURE__ */ t("span", { style: { marginRight: "var(--space-1)" }, "aria-hidden": !0, children: e.pendingAction.icon }) : null,
        e.pendingAction.label
      ]
    }
  ) : /* @__PURE__ */ t(
    "span",
    {
      style: {
        ...h,
        fontStyle: r ? "italic" : "normal"
      },
      children: e.preview
    }
  );
}
function k({ conv: e, pending: a, offTarget: r, labels: s = {} }) {
  const i = [];
  return e.biz && i.push(
    /* @__PURE__ */ t(p, { tone: "neutral", variant: "soft", size: "xs", children: e.biz }, "biz")
  ), i.push(
    /* @__PURE__ */ t(
      p,
      {
        tone: "neutral",
        variant: "outline",
        size: "xs",
        icon: /* @__PURE__ */ t(
          m,
          {
            size: 14,
            initials: e.accountInitials,
            tone: e.accountColor ? "identity" : "neutral",
            identityColor: e.accountColor,
            alt: "",
            "aria-hidden": !0
          }
        ),
        children: e.accountName
      },
      "account"
    )
  ), a && i.push(
    /* @__PURE__ */ t(p, { tone: "magenta", variant: "soft", size: "xs", uppercase: !0, children: s.enPause ?? "⏸ EN PAUSE" }, "enpause")
  ), r && e.offTargetReason && i.push(
    /* @__PURE__ */ o(p, { tone: "neutral", variant: "dashed", size: "xs", style: { maxWidth: 140 }, children: [
      "🚫 ",
      e.offTargetReason
    ] }, "offtarget")
  ), e.source && i.push(
    /* @__PURE__ */ t(R, { source: e.source, size: "xs", children: e.source }, "source")
  ), /* @__PURE__ */ t(
    "div",
    {
      style: {
        marginTop: "var(--space-1_5)",
        display: "flex",
        flexWrap: "wrap",
        gap: "var(--space-1)",
        alignItems: "center"
      },
      children: i
    }
  );
}
export {
  C
};
//# sourceMappingURL=ConvRow-DAa4On4H.js.map
